import { Youtube, Instagram, Facebook } from "lucide-react";

// Custom marks for platforms lucide doesn't ship.
export const TikTokIcon = ({ size = 20, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M16.5 3c.3 2.1 1.6 3.7 3.7 4v2.6c-1.3 0-2.6-.4-3.7-1.1v6.1a5.9 5.9 0 1 1-5.9-5.9c.3 0 .6 0 .9.1v2.7a3.2 3.2 0 1 0 2.3 3.1V3h2.7z" />
  </svg>
);

export const XIcon = ({ size = 20, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M18.244 2h3.308l-7.227 8.26L22.5 22h-6.66l-5.214-6.817L4.66 22H1.35l7.73-8.835L1.5 2h6.83l4.713 6.231L18.244 2Zm-1.161 18h1.833L7.084 3.9H5.117L17.083 20Z" />
  </svg>
);

export const SOCIAL_ICONS = {
  youtube: Youtube,
  instagram: Instagram,
  facebook: Facebook,
  tiktok: TikTokIcon,
  x: XIcon,
};
